const artsColors = {
  ARTS_50: '#FFFDE5',
  ARTS_100: '#FFF8BF',
  ARTS_200: '#FFF394',
  ARTS_600: '#FFD600',
}

export default artsColors
